<template>
  <v-dialog
    v-model="dialog"
    width="80%"
    :fullscreen="$vuetify.breakpoint.xsOnly"
  >
    <v-form ref="form" v-model="valid" @submit.prevent="submit()">
      <v-card :loading="loading">
        <v-card-title>
          <span class="headline">{{ formTitle }}</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <alert-message></alert-message>
            <v-card>
              <v-card-text class="text-center">
                <h1>Total Duration: {{ totalTime }}</h1>
              </v-card-text>
            </v-card>
            <v-skeleton-loader
              v-if="loading"
              class="mx-auto"
              type="table"
            ></v-skeleton-loader>
            <v-data-table
              v-else
              :headers="headers"
              :items="timeclockEntries"
              show-expand
              single-expand
              :loading="loading"
              sort-by="id"
              :sort-desc="true"
              class="elevation-1"
            >
              <template v-slot:top>
                <v-toolbar flat>
                  <v-spacer></v-spacer>
                  <v-btn color="info" dark class="mb-2" @click="onAdd()" v-show="hasAccess('timeClock.add')">
                    Add Time Clock Entry
                  </v-btn>
                </v-toolbar>
              </template>

              <template v-slot:item.actions="{ item }">
                <span style="white-space:nowrap">
                  <v-menu offset-y>
                    <template v-slot:activator="{ on }">
                      <v-btn icon small class="content-ma-0 mr-2" v-on="on">
                        <v-icon small>mdi-cogs</v-icon>
                      </v-btn>
                    </template>
                    <v-list dense>
                      <v-list-item
                        @click="onEdit(item)"
                        v-show="calculateDuration(item) !== 'Running' && hasAccess('timeClock.edit')"
                      >
                        <v-list-item-title>
                          <v-icon small left>mdi-pencil</v-icon>Edit
                        </v-list-item-title>
                      </v-list-item>
                      <v-list-item
                        @click="onDelete(item)"
                        v-show="calculateDuration(item) !== 'Running' && hasAccess('timeClock.delete')"
                      >
                        <v-list-item-title>
                          <v-icon small left>delete</v-icon>Delete
                        </v-list-item-title>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                  <span v-if="isAdmin && calculateDuration(item) === 'Running'">
                    <TimeclockAction
                      :item="item"
                      :parentItem="parentItem"
                      @onUpdate="refresh()"
                    />
                  </span>
                </span>
              </template>

              <template v-slot:item.employee="{ item }">
                {{ item.employeeFirstName }} {{ item.employeeLastName }}
              </template>

              <template v-slot:item.coordinate="{ item }">
                <v-btn-toggle>
                  <v-btn
                    v-if="item.startLatitude && item.startLongitude"
                    x-small
                    @click="onMap(item.startLatitude, item.startLongitude)"
                    >Start</v-btn
                  >

                  <v-btn
                    v-if="item.stopLatitude && item.stopLongitude"
                    x-small
                    @click="onMap(item.stopLatitude, item.stopLongitude)"
                    >Stop</v-btn
                  >
                </v-btn-toggle>
              </template>

              <template v-slot:item.startTime="{ item }">
                <span style="white-space:nowrap">
                  {{ item.startTime | formatDatetime }}
                </span>
              </template>

              <template v-slot:item.stopTime="{ item }">
                <span style="white-space:nowrap">
                  {{
                    item.stopTime ? formatDatetime(item.stopTime) : ` Running `
                  }}
                </span>
              </template>

              <template v-slot:item.duration="{ item }">
                <span style="white-space:nowrap">
                  <ClockerSingle :item="item" />
                </span>
              </template>

              <template v-slot:expanded-item="{ headers, item }">
                <div
                  v-if="$vuetify.breakpoint.xsOnly"
                  class="mr-10 py-5"
                  style="
                    display: flex;
                    flex-direction: column;
                    align-items: end;
                  "
                >
                  <div style="width: fit-content;">
                  <span class="d-flex" style="gap: 5px">
                    <h4>20min Break:</h4>&nbsp;
                    <span v-if="hasOwn(item.questionnaire, 'question1answer')">
                      {{ item.questionnaire.question1answer ? "Yes" : "No" }}
                    </span>
                    <span v-else>Unanswered</span>
                  </span>
                  <span
                    v-if="hasOwn(item.questionnaire, 'question1reason') && 
                      item.questionnaire.question1reason"
                    class="d-flex"
                    style="gap: 5px"
                  >
                    <h4>Reason:</h4>&nbsp;
                    <span>{{ item.questionnaire.question1reason }}</span>
                  </span>
                  <span class="d-flex" style="gap: 5px">
                    <h4>30min Lunch:</h4>&nbsp;
                    <span v-if="hasOwn(item.questionnaire, 'question2answer')">
                      {{ item.questionnaire.question2answer ? "Yes" : "No" }}
                    </span>
                    <span v-else>Unanswered</span>
                  </span>
                  <span
                    v-if="hasOwn(item.questionnaire, 'question2reason') &&
                      item.questionnaire.question2reason"
                    class="d-flex"
                    style="gap: 5px"
                  >
                    <h4>Reason:</h4>&nbsp;
                    <span>{{ item.questionnaire.question2reason }}</span>
                  </span>
                  </div>
                </div>
                <td v-else :colspan="headers.length" class="py-5">
                  <div
                    class="mr-10"
                    style="
                      display: flex;
                      flex-direction: column;
                      align-items: end;
                    "
                  >
                    <div style="width: fit-content;">
                    <span class="d-flex" style="gap: 5px">
                      <h4>20min Break:</h4>&nbsp;
                      <span v-if="hasOwn(item.questionnaire, 'question1answer')">
                        {{ item.questionnaire.question1answer ? "Yes" : "No" }}
                      </span>
                      <span v-else>Unanswered</span>
                    </span>
                    <span
                      v-if="hasOwn(item.questionnaire, 'question1reason') && 
                        item.questionnaire.question1reason"
                      class="d-flex"
                      style="gap: 5px"
                    >
                      <h4>Reason:</h4>&nbsp;
                      <span>{{ item.questionnaire.question1reason }}</span>
                    </span>
                    <span class="d-flex" style="gap: 5px">
                      <h4>30min Lunch:</h4>&nbsp;
                      <span v-if="hasOwn(item.questionnaire, 'question2answer')">
                        {{ item.questionnaire.question2answer ? "Yes" : "No" }}
                      </span>
                      <span v-else>Unanswered</span>
                    </span>
                    <span
                      v-if="hasOwn(item.questionnaire, 'question2reason') &&
                        item.questionnaire.question2reason"
                      class="d-flex"
                      style="gap: 5px"
                    >
                      <h4>Reason:</h4>&nbsp;
                      <span>{{ item.questionnaire.question2reason }}</span>
                    </span>
                    </div>
                  </div>
                </td>
              </template>

              <template v-slot:item.questionnaire.notes="{ item }">
                <div v-if="hasOwn(item.questionnaire, 'question2reason') &&
                  item.questionnaire.notes"
                >
                  <div
                    v-if="$vuetify.breakpoint.xsOnly"
                  >
                    {{ item.questionnaire.notes }}
                  </div>
                  <div
                    v-else
                    style="min-width: 25ch"
                  >
                    {{ item.questionnaire.notes }}
                  </div>
                </div>
              </template>
            </v-data-table>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="darken-1" @click="dialog = false">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-form>

    <FormTimeEntry
      :show="showForm"
      :parentItem="parentItem"
      :item="selectedItem"
      :client-id="clientId"
      @onClosed="clearForm()"
      @onSucceded="refresh()"
    />

    <DeleteTimeEntry
      :show="showDelete"
      :item="selectedItem"
      :client-id="clientId"
      @onClosed="clearForm()"
      @onSucceded="refresh()"
    />

    <MapDialog
      :show="showMap"
      :lat="mapItem.lat"
      :lng="mapItem.lng"
      @onClosed="clearMap()"
    />
  </v-dialog>
</template>

<script>
import { mapActions, mapState, mapGetters } from "vuex";
import AlertMessage from "src/components/AlertMessage";
import { required } from "vuelidate/lib/validators";
import validationMixin from "@/mixins/validationMixin";
import formatterMixin from "@/mixins/formatterMixin";
import moment from "moment";
import FormTimeEntry from "./TimeclockEntry/_Form";
import DeleteTimeEntry from "./TimeclockEntry/_Delete";
import ClockerSingle from "./Timeclock/__ClockerSingle";
import MapDialog from "./TimeclockEntry/_Map";
import TimeclockAction from "./Timeclock/__TimeclockSingleAction";

export default {
  components: {
    AlertMessage,
    FormTimeEntry,
    DeleteTimeEntry,
    ClockerSingle,
    MapDialog,
    TimeclockAction,
  },
  props: {
    clientId: Number,
    item: Object,
    show: [Boolean, String],
  },
  mixins: [validationMixin, formatterMixin],
  validations: {
    form: {
      name: {
        required,
      },
      type: { required },
      clientId: { required },
      description: { required },
      rate: { required },
      items: { required },
    },
  },
  validationMessages: {
    form: {
      name: {
        required: "Required",
      },
      type: {
        required: "Required",
      },
      description: {
        required: "Required",
      },
      clientId: {
        required: "Required",
      },
      rate: {
        required: "Required",
      },
      items: {
        required: "Required",
      },
    },
  },

  data() {
    return {
      showDialog: this.show,
      showForm: false,
      showDelete: false,
      showMap: false,
      mapItem: {},
      selectedItem: {},

      dialog: false,
      valid: false,
      loading: false,

      timeclockEntries: [],

      headers: [
        { text: "Action", value: "actions", sortable: false },
        { text: "ID", value: "id", sortable: true },
        { text: "Employee", value: "employee" },
        { text: "Start", value: "startTime" },
        { text: "Stop", value: "stopTime" },
        { text: "Map", value: "coordinate" },
        { text: "Duration", value: "duration" },
        { text: "Notes", value: "questionnaire.notes", sortable: false },
        { text: "", value: "data-table-expand" },
      ],
    };
  },

  watch: {
    show(n, o) {
      if (n && !o) {
        this.dialog = true;
      }
    },

    dialog(show) {
      if (!show) {
        this.onDialogClose();
      } else {
        this.onDialogOpen();
      }
    },
  },

  computed: {
    ...mapGetters("account", ["hasAccess"]),
    ...mapState({
      account: (state) => state.account,
      isAdmin: (state) => state.account.data.isAdmin,
      timeclock: (state) => state.timeclock.single,
      alert: (state) => state.alert,
      parentItem: (state) => state.task.single,
    }),
    formTitle() {
      return `${this.item.name} Time Entries`;
    },
    isEdit() {
      return this.optional(this.item, "id", "") ? true : false;
    },
    timeclockId() {
      return this.optional(this.item, "id", "");
    },

    totalTime() {
      return this.formatTimeRoundupSecond(
        this.sumTimeClockEntries(this.timeclockEntries)
      );
    },
  },

  async mounted() {
    await this.refresh();
  },

  methods: {
    ...mapActions("timeclock", ["create", "update"]),
    ...mapActions({
      taskGetById: "task/getById",
    }),

    hasOwn(obj, key) {
      if(!obj){
        return false
      }
      return hasOwnProperty.call(obj, key);
    },

    onMap(lat, lng) {
      this.showMap = true;
      this.mapItem = { lat, lng };
    },
    clearMap() {
      this.showMap = false;
      this.mapItem = {};
    },
    clearForm() {
      this.showForm = false;
      this.showDelete = false;
      this.selectedItem = {};
    },
    clearDelete() {
      this.showDelete = false;
      this.selectedItem = {};
    },
    onEdit(item) {
      this.showForm = true;
      this.selectedItem = item;
    },
    onAdd() {
      this.showForm = true;
      this.selectedItem = {
        taskId: this.item.id,
      };
    },
    onDelete(item) {
      this.showDelete = true;
      this.selectedItem = item;
    },
    calculateDuration(item) {
      let start = moment(item.startTime).utc(true);
      if (item.stopTime) {
        let end = moment(item.stopTime).utc(true);
        return this.formatTimeRoundupSecond(
          parseInt(Math.abs(start.diff(end)) / 1000)
        );
      } else {
        return "Running";
      }
    },
    initForm() {},
    serverSideErrors(field) {
      return this.optional(this.task.errors, field, []);
    },
    onDialogClose() {
      if (this.isEdit) {
        //
      } else {
        //
      }
      this.$emit("onClosed");
    },

    async onDialogOpen() {
      this.$nextTick(() => {
        // clear error state
        this.$store.dispatch("alert/clear");
        this.$v.$reset();
      });

      await this.refresh();
    },

    save() {},
    addNew() {
      this.dialog = true;
    },
    completed() {
      this.$emit("onSucceded");
    },
    async refresh() {
      this.clearForm();
      this.loading = true;
      if (this.item?.id) {
        await this.taskGetById(this.item.id);
      }
      this.timeclockEntries = this.parentItem?.timeClockEntries?.map((entry) =>
        this.formatEntry(entry)
      ) || [];
      this.loading = false;
    },

    formatEntry(entry) {
      let dateStart = moment(entry.startTime).format("YYYY-MM-DD");
      let timeStart = moment(entry.startTime).format("HH:mm:ss");
      let dateEnd = moment(entry.stopTime).format("YYYY-MM-DD");
      let timeEnd = moment(entry.stopTime).format("HH:mm:ss");
      return {
        ...entry,
        dateStart: dateStart,
        timeStart: timeStart,
        dateEnd: dateEnd,
        timeEnd: timeEnd,
      };
    },

    async submit() {
      this.loading = true;
      if (!this.valid) {
        this.$store.dispatch("snackbar/error", "Form invalid");
        return false;
      }

      let payload = {
        ...this.form,
        startTime: moment(`${this.form.dateStart} ${this.form.timeStart}`).utc(
          true
        ),
        stopTime: moment(`${this.form.dateEnd} ${this.form.timeEnd}`).utc(true),
      };

      if (this.isEdit) {
        await this.update({
          id: this.item.id,
          ...payload,
        });
      } else {
        delete payload.id;
        await this.create(payload);
      }

      if (!this.timeclockEntry.status.error) {
        this.dialog = false;
        this.completed();
      }
      this.loading = false;
    },
  },
};
</script>